import React, { useEffect, useState } from "react";
import "./Guest_house.css";
import Breadcrumb_Comp from "../common/common_components/breadcrumb_comp/Breadcrumb_Comp";
import Common_Title_1 from "../common/common_components/common_title_1/Common_Title_1";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import Spritual_stay_card from "../common/common_components/spritual-stay-card/Spritual_stay_card";
import { useDispatch, useSelector } from "react-redux";
import { AllRoomTypes } from "../../features/admin/common/Slice";
import { GetAllRooms } from "../../features/admin/room/slice";
import { IDS } from "../../utils/IDS";

const Guest_house = () => {
  const breadcrumbs = [
    { label: "Explore", link: "/explore", active: false },
    {
      label: "Your Spiritual Stay",
      link: "/guest-house",
      active: true,
    },
  ];

  const [selectedRoomType, setSelectedRoomType] = useState("all");

  const dispatch = useDispatch();
  const roomTypes = useSelector((state) => state.common.all_room_Types);
  const rooms = useSelector((state) => state.stay.room);

  useEffect(() => {
    if (selectedRoomType === "all") {
      dispatch(GetAllRooms({})); // fetch all rooms
    } else {
      dispatch(GetAllRooms({ roomType: selectedRoomType })); // fetch by type
    }
  }, [selectedRoomType, dispatch]);

  useEffect(() => {
    dispatch(AllRoomTypes());
  }, [dispatch]);
  return (
    <>
      <div className="container-lg">
        <Breadcrumb_Comp data={breadcrumbs} />

        <div className="guest_book_sec">
          <Common_Title_1 subText={"Your Spiritual Stay"} />

          <div className="tabsec">
            <Tab.Container
              activeKey={selectedRoomType}
              onSelect={(k) => setSelectedRoomType(String(k))}
            >
              <Nav variant="pills" className="flex-row">
                {/* All tab */}
                <Nav.Item>
                  <Nav.Link eventKey="all">All</Nav.Link>
                </Nav.Item>

                {/* Dynamic room type tabs */}
                {roomTypes.length === 0 ? (
                  <Nav.Item>
                    <Nav.Link eventKey="no-types">No room types</Nav.Link>
                  </Nav.Item>
                ) : (
                  roomTypes.map((rt) => (
                    <Nav.Item key={rt.value}>
                      <Nav.Link eventKey={String(rt.value)}>
                        {rt.label}
                      </Nav.Link>
                    </Nav.Item>
                  ))
                )}
              </Nav>

              <Tab.Content>
                <Tab.Pane eventKey={selectedRoomType}>
                  <div className="row">
                    {/* Use rooms.data directly — no local filtering */}
                    {!rooms?.data || rooms?.data?.length === 0 ? (
                      <div className="col-12 text-center py-4">
                        <p>No rooms available for this type.</p>
                      </div>
                    ) : (
                      rooms?.data?.map((room) => (
                        <div
                          className="col-lg-6 col-sm-6 mb-md-4 mb-2"
                          key={room.id}
                        >


                          <Spritual_stay_card
                            id={room.id}
                            name={room.name}
                            image={IDS.IMG_URL + room.image}
                            price={room.price}
                            isBooked={room.book_status}
                          />
                        </div>
                      ))
                    )}
                  </div>
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </div>
        </div>
      </div>
    </>
  );
  // return (
  //     <>
  //         <div className='container-lg'>
  //             <Breadcrumb_Comp data={breadcrumbs} />

  //             <div className='guest_book_sec'>
  //                 <Common_Title_1 subText={'Your Spiritual Stay'} />

  //                 <div className='tabsec'>
  //                     <Tab.Container id="left-tabs-example" defaultActiveKey="acrooom">
  //                         <Nav variant="pills" className="flex-row">
  //                             <Nav.Item>
  //                                 <Nav.Link eventKey="acrooom">AC Rooms</Nav.Link>
  //                             </Nav.Item>
  //                             <Nav.Item>
  //                                 <Nav.Link eventKey="nonacroom">Non AC Rooms</Nav.Link>
  //                             </Nav.Item>
  //                         </Nav>

  //                         <Tab.Content>
  //                             <Tab.Pane eventKey="acrooom">
  //                                 <div className='row'>
  //                                     {Array?.from({ length: 6 })?.map(
  //                                         ((_, index) => (
  //                                             <div className='col-lg-6 col-sm-6 mb-md-4 mb-2'>
  //                                                 fgdfgdfgfgfd
  //                                                 <Spritual_stay_card />
  //                                             </div>
  //                                         ))
  //                                     )}
  //                                 </div>
  //                             </Tab.Pane>
  //                             <Tab.Pane eventKey="nonacroom">
  //                                 <div className='row'>
  //                                     {Array?.from({ length: 6 })?.map(
  //                                         ((_, index) => (
  //                                             <div className='col-lg-6 col-sm-6 mb-md-4 mb-2'>
  //                                                 <Spritual_stay_card />
  //                                             </div>
  //                                         ))
  //                                     )}
  //                                 </div>
  //                             </Tab.Pane>
  //                         </Tab.Content>
  //                     </Tab.Container>
  //                 </div>
  //             </div>
  //         </div>
  //     </>
  // )
};

export default Guest_house;
